



































import { Component, Inject, Prop, Mixins } from "vue-property-decorator";
import { IBasketProviderData } from "@/models/providers/baskets";
import { IBasketRoute } from "@/models/baskets";
import Context from "@/mixins/context"; // Used in menu.ts

@Component
export default class BasketStepper extends Mixins(Context) {
  // Inject
  @Inject({ from: "providerData" })
  public readonly $basketData!: () => IBasketProviderData;
  // Props
  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];
  // Computed
  public get basketData() {
    return this.$basketData();
  }
  public get filteredRoutes() {
    return this.$_.map(
      this.$_.filter(this.basketRoutes, route => {
        return this.$_.get(route, "if", () => true)(this);
      }),
      route => ({
        ...route,
        to: route.to(this),
        isDisabled: this.$_.get(route, "isDisabled", () => false)(this)
      })
    );
  }
}
